/**
 * ESM re-export of the global jQuery from site/meta/head.blade.php.
 * Used by Vite serve/inject (`import $ from 'jquery'`) so the browser gets a real
 * `default` export. The companion `.cjs` file is resolved for country-select-js's
 * `require("jquery")` path (see vite.config.js).
 */
const jq = typeof window !== 'undefined' ? (window.jQuery || window.$) : undefined;

if (!jq) {
    throw new Error(
        'jQuery must be loaded before Vite modules (site layout head).',
    );
}

export default jq;
